import { render, staticRenderFns } from "./PriceLevelSettings.vue?vue&type=template&id=356a9840&scoped=true&"
import script from "./PriceLevelSettings.vue?vue&type=script&lang=js&"
export * from "./PriceLevelSettings.vue?vue&type=script&lang=js&"
import style0 from "./PriceLevelSettings.vue?vue&type=style&index=0&id=356a9840&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356a9840",
  null
  
)

export default component.exports